import { graphql, fetchQuery_DEPRECATED as fetchQuery, Environment } from 'react-relay/legacy';
import { Dispatch, Store } from 'redux';

import { SHOW_SHOP_LOCAL_TOAST } from './shopLocalConstants';
import { hasRecentlyDismissedShopLocalPrompt } from './shopLocalHelpers';

import {
    shopLocalConfigQuery,
    shopLocalConfigQuery$data,
} from './__generated__/shopLocalConfigQuery.graphql';

const shouldShowShopLocal = async ({
    relayEnvironment,
    store,
}: {
    relayEnvironment: Environment;
    store: Store;
}): Promise<boolean> => {
    // dispatch action not to overlap shopLocal and footer marketing banners
    const hideMarketingBanner = (value: boolean): void => {
        store.dispatch({
            type: SHOW_SHOP_LOCAL_TOAST,
            showShopLocalToast: value,
        });
    };

    if (hasRecentlyDismissedShopLocalPrompt()) {
        hideMarketingBanner(false);
        return Promise.resolve(false);
    }

    const response: shopLocalConfigQuery$data = await fetchQuery<shopLocalConfigQuery>(
        relayEnvironment,
        graphql`
            query shopLocalConfigQuery {
                viewer {
                    shopLocalNotificationFeatureFlag: featureFlag(feature: "shopLocalNotification")
                }
            }
        `,
        {}
    );

    const showShopLocal = Boolean(response.viewer.shopLocalNotificationFeatureFlag);

    hideMarketingBanner(showShopLocal);

    return showShopLocal;
};

export const shopLocalConfig = {
    name: 'shopLocal',
    rule: shouldShowShopLocal,
    action: (): unknown => (dispatch: Dispatch) => {
        dispatch({
            type: SHOW_SHOP_LOCAL_TOAST,
            showShopLocalToast: true,
        });
    },
    priority: 50,
};
